import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const navigateRef = { current: null };

export const navigate = (to, options) => {
    if (!navigateRef.current) {
        console.error('navigate called before router mounted', { to, options });
        return;
    }
    navigateRef.current(to, options);
};

export const NavigationSetter = () => {
    const navigateFn = useNavigate();
    useEffect(() => {
        navigateRef.current = navigateFn;
        return () => {
            navigateRef.current = null;
        };
    }, [navigateFn]);
    return null;
};
